// src/components/blogs/BlogForm.jsx
import React from 'react'
import { Form, Modal } from 'react-bootstrap'
import ReactQuill from 'react-quill'
import { KTSVG } from '../../../_metronic/helpers'
import 'react-quill/dist/quill.snow.css'
import slugify from 'slugify'

const BlogForm = ({
    lgshow,
    handleClose,
    modalTitle,
    viewMode,
    blogTitle,
    setBlogTitle,
    blogMetaTitle,
    setBlogMetaTitle,
    blogMetaKeywords,
    setBlogMetaKeywords,
    blogMetaDescription,
    setBlogMetaDescription,
    blogStatus,
    setBlogStatus,
    quillValue,
    setQuillValue,
    fileFormatErrorThumbnail,
    fileSizeErrorThumbnail,
    handleThumbnail,
    isEditThumbnail,
    thumbnail_selected,
    blogDescription,
    setBlogDescription,
    handleBlogForm,
    modules,
    quillRef,
    formats,
    slug,
    setSlug,
    thumbNailAlt,
    setThumbNailAlt,
}) => {
    return (
        <Modal onHide={handleClose} className="modal fade" size="lg" show={lgshow}>
            <div className="modal-header pb-0 border-0 justify-content-end">
                <div
                    className="btn btn-sm btn-icon btn-active-color-primary"
                    data-bs-dismiss="modal"
                    onClick={handleClose}
                >
                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
                </div>
            </div>
            <Modal.Body className="modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15">
                <div className="text-center mb-13">
                    <h1 className="mb-3">{modalTitle}</h1>
                </div>

                <Form onSubmit={handleBlogForm}>
                    <Form.Group className="mt-3" controlId="BlogTitle">
                        <Form.Label>
                            Blog Title <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            className="form-control-sm"
                            type="text"
                            placeholder="Enter blog title"
                            value={blogTitle}
                            onChange={(e) => {
                                const finalSlug = slugify(e.target.value, { lower: true })
                                setSlug(finalSlug)
                                setBlogTitle(e.target.value)
                            }}
                            required
                            disabled={viewMode}
                        />
                    </Form.Group>
                    <Form.Group className="mt-3" controlId="MetaTitle">
                        <Form.Label>
                            Meta Title <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            className="form-control-sm"
                            type="text"
                            placeholder="Enter meta title"
                            value={blogMetaTitle}
                            onChange={(e) => setBlogMetaTitle(e.target.value)}
                            required
                            disabled={viewMode}
                        />
                    </Form.Group>
                    <Form.Group className="mt-3" controlId="MetaKeywords">
                        <Form.Label>
                            Meta Keywords <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            className="form-control-sm"
                            type="text"
                            placeholder="Enter meta keywords"
                            value={blogMetaKeywords}
                            onChange={(e) => setBlogMetaKeywords(e.target.value)}
                            required
                            disabled={viewMode}
                        />
                    </Form.Group>
                    <Form.Group className="mt-3" controlId="MetaDescription">
                        <Form.Label>
                            Meta Description <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            className="form-control-sm"
                            type="text"
                            placeholder="Enter meta description"
                            value={blogMetaDescription}
                            onChange={(e) => setBlogMetaDescription(e.target.value)}
                            required
                            disabled={viewMode}
                        />
                    </Form.Group>
                    <Form.Group className="mt-3" controlId="Slug">
                        <Form.Label>
                            Slug <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            className="form-control-sm"
                            type="text"
                            placeholder="Enter slug"
                            value={slug}
                            onChange={(e) => {
                                const finalSlug = e.target.value.toLowerCase().replaceAll(' ', '-')
                                setSlug(finalSlug)
                            }}
                            required
                            disabled={viewMode}
                        />
                    </Form.Group>
                    <Form.Group className="mt-3" controlId="formBasicStatus">
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                            aria-label="Default select example"
                            className="form-select-sm"
                            value={blogStatus}
                            onChange={(e) => setBlogStatus(e.target.value)}
                            disabled={viewMode}
                        >
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group controlId="formBasicPhoto" className="mt-5 mb-2">
                        <Form.Label>
                            Thumbnail <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Text className="text-muted">
                            {fileSizeErrorThumbnail && (
                                <div className="text-danger">(File size must be less than 300kb)</div>
                            )}
                            {fileFormatErrorThumbnail && (
                                <div className="text-danger">(File must be jpg / png / svg)</div>
                            )}
                        </Form.Text>
                        {!viewMode && (
                            <Form.Control
                                className="form-control-sm"
                                type="file"
                                placeholder="Enter Category Name"
                                onChange={handleThumbnail}
                            />
                        )}
                    </Form.Group>
                    {isEditThumbnail && (
                        <img src={thumbnail_selected} alt="" width="100px" height="100px" className="mb-3" />
                    )}
                    <Form.Group className="mt-3" controlId="ImageAlt">
                        <Form.Label>Thumbnail Alt</Form.Label>
                        <Form.Control
                            className="form-control-sm"
                            type="text"
                            placeholder="Enter thumbnail alt"
                            value={thumbNailAlt}
                            onChange={(e) => setThumbNailAlt(e.target.value)}
                            required
                            disabled={viewMode}
                        />
                    </Form.Group>

                    <Form.Group className="mt-5 mb-2" controlId="Description">
                        <Form.Label>Short Description</Form.Label>
                        <textarea
                            className="form-control"
                            rows="3"
                            placeholder="Enter short description"
                            value={blogDescription}
                            onChange={(e) => setBlogDescription(e.target.value)}
                            disabled={viewMode}
                        ></textarea>
                    </Form.Group>
                    <Form.Group className="mt-3" controlId="BlogContent">
                        <Form.Label>
                            Blog Content <span className="text-danger">*</span>
                        </Form.Label>
                        <div>
                            <ReactQuill
                                theme="snow"
                                ref={quillRef}
                                value={quillValue}
                                onChange={setQuillValue}
                                modules={modules}
                                formats={formats}
                                disabled={viewMode}
                            />
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            {!viewMode && (
                <div className="modal-footer d-flex justify-content-center pt-4">
                    <button
                        type="button"
                        className="btn btn-sm btn-flex btn-light btn-active-light-primary me-2"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-flex btn-primary"
                        id="btn-submit"
                        onClick={handleBlogForm}
                    >
                        {modalTitle}
                    </button>
                </div>
            )}
        </Modal>
    )
}

export default BlogForm
